import React from "react";
import Login from "../services/login";
import { hasAuth } from "../services/api";

class ResponsiveLogin extends React.Component {
  componentDidMount() {
    if (hasAuth()) {
      this.props.history.replace("/account");
      return;
    }
    Login("/account");
  }
  render() {
    return null;
  }
}

export default ResponsiveLogin;
